import React from "react";
import { ListItem, UnorderedList } from "@chakra-ui/react";
import { MarkdownRenderer } from "./MarkdownRenderer";

type ChangelogProps = {
  changes: readonly string[];
};

export const Changelog = ({ changes }: ChangelogProps) => {
  return (
    <UnorderedList fontSize="md">
      {changes.map((change, index) => (
        <ListItem key={index}>
          <MarkdownRenderer>{change}</MarkdownRenderer>
        </ListItem>
      ))}
    </UnorderedList>
  );
};
